import React from 'react';
import { Music, ExternalLink } from 'lucide-react';
import { personalInfo } from '../data/mock';

const ZahaMusic = () => {
  return (
    <section id="music" className="relative py-24 bg-gradient-to-br from-[#f7fafc] via-white to-[#edf2f7] overflow-hidden">
      {/* Organic shape */}
      <div className="absolute top-20 right-0 w-[600px] h-[600px] opacity-[0.08]">
        <div className="w-full h-full bg-gradient-to-br from-[#a0aec0] to-transparent"
          style={{ borderRadius: '45% 55% 62% 38% / 53% 47% 53% 47%', animation: 'float-smooth 12s ease-in-out infinite' }}
        />
      </div>
      
      <div className="relative z-10 max-w-6xl mx-auto px-8">
        <div className="mb-16">
          <div className="inline-block mb-6">
            <p className="text-xs font-medium text-[#a0aec0] uppercase tracking-[0.25em]">
              Creative Projects
            </p>
            <div className="w-16 h-[1px] bg-gradient-to-r from-[#cbd5e0] to-transparent mt-4" />
          </div>
          
          <h2 className="text-5xl md:text-6xl font-light text-[#2d3748]">
            Music &
            <br />
            <span className="font-medium">Curation</span>
          </h2>
        </div>

        <div className="grid lg:grid-cols-12 gap-8">
          <div className="lg:col-span-7">
            <div className="bg-white zaha-shadow-lg overflow-hidden"
              style={{ borderRadius: '50px 30px 50px 30px' }}
            >
              <div className="p-8 border-b border-[#edf2f7]">
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-4">
                    <div className="w-12 h-12 bg-gradient-to-br from-[#cbd5e0] to-[#a0aec0] flex items-center justify-center"
                      style={{ borderRadius: '12px 8px 12px 8px' }}
                    >
                      <Music className="text-white" size={20} />
                    </div>
                    <div>
                      <h3 className="text-lg font-medium text-[#2d3748]">DJ / Curator</h3>
                      <p className="text-sm text-[#a0aec0]">Underground Electronic</p>
                    </div>
                  </div>
                  <a
                    href={personalInfo.soundcloud}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-[#718096] hover:text-[#2d3748] transition-colors"
                  >
                    <ExternalLink size={18} />
                  </a>
                </div>
              </div>
              
              <div className="p-8">
                <iframe 
                  width="100%" 
                  height="300" 
                  scrolling="no" 
                  frameBorder="no" 
                  allow="autoplay"
                  src="https://w.soundcloud.com/player/?url=https%3A//soundcloud.com/nbrae&color=%23718096&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true"
                  title="SoundCloud Player"
                  className="w-full"
                  style={{ borderRadius: '20px' }}
                />
              </div>
            </div>
          </div>

          <div className="lg:col-span-5 space-y-6">
            {['Garage', 'Techno', 'House'].map((genre, idx) => (
              <div key={idx} className="bg-gradient-to-br from-[#f7fafc] to-white p-6 zaha-shadow"
                style={{ borderRadius: '30px 40px 30px 40px' }}
              >
                <p className="text-2xl font-light text-[#2d3748]">{genre}</p>
              </div>
            ))}

            <div className="bg-gradient-to-br from-[#2d3748] to-[#4a5568] p-8 text-white mt-8"
              style={{ borderRadius: '40px 30px 40px 30px' }}
            >
              <p className="text-xs text-white/60 uppercase tracking-wider mb-2">Event Series</p>
              <h3 className="text-3xl font-light mb-3">Festa</h3>
              <p className="text-sm text-white/80 mb-6">London underground collective</p>
              <a
                href="https://festa.london/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block px-6 py-3 bg-white text-[#2d3748] font-medium text-sm hover:bg-white/90 transition-colors"
                style={{ borderRadius: '25px 20px 25px 20px' }}
              >
                Visit Site
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ZahaMusic;